import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaLayerGroup, FaBars, FaBoxOpen, FaBullhorn, FaBlog, FaSearch } from 'react-icons/fa';
import '../../styles/Sidebar.css';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const menuItems = [
    // { path: '/dashboard', icon: <FaTachometerAlt />, label: 'Dashboard' },
    // { path: '/users', icon: <FaUsers />, label: 'Users Management' },
    { path: '/products', icon: <FaBoxOpen />, label: 'Product Management' },
    // { path: '/brands', icon: <FaTags />, label: 'Brand Management' },
    { path: '/categories', icon: <FaLayerGroup />, label: 'Product Categories' },
    { path: '/promotions', icon: <FaBullhorn />, label: 'Promotions' },
    { path: '/blogs', icon: <FaBlog />, label: 'Blogs' },
    { path: '/seo-settings', icon: <FaSearch />, label: 'SEO Settings' },
    // { path: '/roles', icon: <FaUserShield />, label: 'Roles & Permissions' },
    // { path: '/reports', icon: <FaChartBar />, label: 'Reports' },
    // { path: '/settings', icon: <FaCog />, label: 'Settings' },
  ];

  return (
    <>
      <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <h2>ECBioLabs</h2>
          <button className="toggle-btn desktop" onClick={toggleSidebar}>
            <FaBars />
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul>
            {menuItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) => (isActive ? 'active' : '')}
                  onClick={() => window.innerWidth <= 768 && toggleSidebar()}
                >
                  <span className="icon">{item.icon}</span>
                  <span className="label">{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      {isOpen && window.innerWidth <= 768 && (
        <div className="sidebar-overlay" onClick={toggleSidebar} />
      )}
    </>
  );
};

export default Sidebar;
